import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { HookedSwitch } from './HookedSwitch';

interface Props extends ChakraV3.StackProps {
  name: string;
  label: string;
  helperText?: string;
  labelSize?: 'md' | 'sm';
}

export const HookedMethodFormField = (props: React.PropsWithChildren<Props>) => {
  const { name, label, labelSize, helperText, children, ...rest } = props;

  return (
    <ChakraV3.Field.Root
      as={ChakraV3.Stack}
      w='full'
      gap={0}
      borderColor='gray.200'
      borderWidth='1px'
      rounded='md'
      py={3}
      px={4}
      align='start'
      {...rest}
    >
      <ChakraV3.HStack w='full'>
        <ChakraV3.Field.Label fontWeight='semibold' mb={0} color='gray.700' fontSize={labelSize}>
          {label}
        </ChakraV3.Field.Label>
        <ChakraV3.Spacer />
        <HookedSwitch name={`${name}.enabled`} />
      </ChakraV3.HStack>
      {helperText && (
        <ChakraV3.Field.HelperText fontSize='xs' whiteSpace='pre-wrap' mt={0}>
          {helperText}
        </ChakraV3.Field.HelperText>
      )}
      {children}
    </ChakraV3.Field.Root>
  );
};
